<template>
  <div>
    <Loader v-if="!isDataLoaded"/>
    <div v-else>
      <Director
        v-for='director in vcloud'
        :key=director.id
        :pools="director.pools"
        :name="director.director"
        :host="director.host"
        displayEdit
        />
    </div>

    <section class="section">
      <HeaderSection :title="$t('views.directorPools.title')"/>
      <Loader v-if="!isChartLoaded"/>

      <line-chart
        v-for="(chartData, index) in graphData"
        :key="chartData.name"
        :chart-data="chartData"
        :options="graphOptions[index]"
        :height="500"/>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import DIRECTOR from '@/api/director';
import GRAPH from '@/api/graph';
import PROBLEMS from '@/api/problems';

import Loader from '@/components/Loader.vue';
import HeaderSection from '@/components/HeaderSection.vue';
import LineChart from '@/components/LineChart';

export default {
  name: 'directorPools',
  components: {
    Director: () => import('@/components/ProgressGroupDirector'),
    Loader,
    HeaderSection,
    LineChart,
  },
  data() {
    return {
      isChartLoaded: false,
      vcloud: null,
      graphData: [],
      graphDataIn: [],
      graphDataOut: [],
      graphOptions: [],
      chartOptions: {
        type: 'line',
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: '',
        },
        tooltips: {
          mode: 'x',
          axis: 'y',
          intersect: false,
        },
        hover: {
          mode: 'x',
          intersect: false,
        },
        legend: {
          labels: {
            boxWidth: 50,
          },
        },
        scales: {
          xAxes: [{
            distribution: 'linear',
            display: true,
            type: 'time',
            time: {
              unit: 'minute',
              unitStepSize: 5,
              displayFormats: {
                minute: 'h:mm a',
              },
            },
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('views.directorPools.config.mbps'),
            },
          }],
        },
      },
    }
  },
  computed: {
    isDataLoaded() {
      return (this.vcloud);
    },
  },
  created() {
    this.getDirector();
    this.getOutgoingGraph();
  },
  methods: {
    getDirector() {
      DIRECTOR.list().then(
        (res) => {
          if (res && res.data) {
            this.vcloud = res.data;
          }
        },
      );
    },

    setChartData() {
      this.graphDataOut.forEach((data, index) => {
        this.graphData.push({
          name: data.name,
          datasets: [
            {
              label: `${data.name} ` + this.$t('views.directorPools.config.out'),
              fill: false,
              pointRadius: 2,
              backgroundColor: '#62DEC3',
              borderColor: '#62DEC3',
              data: data.data,
            },
            {
              label: `${data.name} ` + this.$t('views.directorPools.config.in'),
              fill: false,
              pointRadius: 2,
              backgroundColor: '#F39449',
              borderColor: '#F39449',
              data: this.graphDataIn[index].data,
            },
          ],
        });

        this.graphOptions.push(Object.assign({ ...this.chartOptions }, {
          title: {
            text: this.getChartTitle(data.name),
            display: true,
          },
        }));
      });
    },

    mapData(res) {
      const graphData = res.map((graph) => {
        graph.data = graph.data.map(data => ({
          x: new Date(data.x * 1000),
          y: data.y,
        }));
        return graph;
      });
      return graphData;
    },

    getOutgoingGraph() {
      axios.all([GRAPH.OutgoingGraph(), GRAPH.IncomingGraph()])
        .then(axios.spread((outgoing, incoming) => {
          this.graphDataOut = this.mapData(outgoing.data);
          this.graphDataIn = this.mapData(incoming.data);
          this.isChartLoaded = true;
          this.setChartData();
        }));
    },

    getChartTitle(chartName) {
      const today = new Date();
      const options = {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
      };
      return `${chartName} ${today.toLocaleDateString(this.$i18n.locale, options)}`;
    },
  },
};
</script>
